export default "__VITE_ASSET__BoazYpYw__"